import actions from "./actions";

const { SAVE_QUOTES_DATA } = actions;

const initState = {
  quotesData: []
};

/**
 *
 * @todo impure state mutation/explaination
 */
const QuotesReducer = (state = initState, action) => {
  //data, err
  const { type } = action;
  switch (type) {
    case SAVE_QUOTES_DATA:
      return {
        ...state,
        quotesData: action.quotesData
      };
    default:
      return state;
  }
};
export default QuotesReducer;
